import { cn } from '@speedlo/ui'
import React from 'react'
import styled from 'styled-components/macro'

import speedloLogo from '../../assets/img/speedlo-logo.png'

type TProps = {
  bigLogo: boolean
}

const StyledShopHeaderIcons = styled.div`
  display: grid;
  justify-items: center;
  height: 2.5rem;
  grid-template-rows: 2.5rem;

  .logo {
    height: 100%;
  }

  &.big-logo {
    justify-items: left;

    .logo {
      transform-origin: top left;
      transform: scale(3) translateY(-0.48rem);
    }
  }
`

export const ShopHeaderIcons: React.FC<TProps> = ({ bigLogo }) => {
  return (
    <StyledShopHeaderIcons className={cn({ 'big-logo': bigLogo })}>
      <img src={speedloLogo} alt="speedlo logo" className="logo" />
    </StyledShopHeaderIcons>
  )
}
